import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import match from 'autosuggest-highlight/match';
import parse from 'autosuggest-highlight/parse';
import { TextField, Paper, MenuItem } from '@material-ui/core/';
import { withStyles } from '@material-ui/core/styles';

const renderInputComponent = (inputProps) => {
    const {
        classes,
        inputRef = () => {},
        ref,
        ...other
    } = inputProps;

    return (
        <TextField
            InputProps={{
                inputRef: (node) => {
                    ref(node);
                    inputRef(node);
                },
                classes: {
                    input: classes.input,
                },
            }}
            fullWidth
            margin="dense"
            variant="outlined"
            {...other}
        />
    );
};

const renderSuggestion = (suggestion, { query, isHighlighted }) => {
    const matches = match(suggestion, query);
    const parts = parse(suggestion, matches);

    return (
        <MenuItem selected={isHighlighted} component="div">
            <div>
                {parts.map((part, index) => (part.highlight ? (
                    <span key={String(index)} style={{ fontWeight: 600 }}>
                        {part.text}
                    </span>
                ) : (
                    <strong key={String(index)} style={{ fontWeight: 400 }}>
                        {part.text}
                    </strong>
                )))}
            </div>
        </MenuItem>
    );
};

const renderSuggestionsContainer = options => (
    <Paper {...options.containerProps} square style={{ zIndex: 100 }}>
        {options.children}
    </Paper>
);

const styles = theme => ({
    root: {
        flexGrow: 1,
    },
    container: {
        position: 'relative',
    },
    suggestionsContainerOpen: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing(1),
        left: 0,
        right: 0,
    },
    suggestion: {
        display: 'block',
    },
    suggestionsList: {
        margin: 0,
        padding: 0,
        listStyleType: 'none',
    },
});

const Autocomplete = (props) => {
    const {
        classes,
        value,
        label,
        placeholder,
        handleChange,
        getSuggestions,
        getHistory,
        inputName,
    } = props;

    const [suggestions, setSuggestions] = useState([]);

    const onSuggestionsFetchRequested = ({ value: query }) => {
        if (query.length === 0) {
            setSuggestions(getHistory());
            return;
        }

        getSuggestions(query)
            .then(data => setSuggestions(data || []));
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const getSuggestionValue = suggestion => suggestion;

    const onChange = (e, { newValue }) => {
        handleChange(newValue);
    };

    const autosuggestProps = {
        renderInputComponent,
        suggestions,
        getSuggestionValue,
        onSuggestionsFetchRequested,
        onSuggestionsClearRequested,
        renderSuggestion,
        renderSuggestionsContainer,
        shouldRenderSuggestions: () => true,
    };

    const inputProps = {
        classes,
        label,
        placeholder,
        value,
        onChange,
        name: inputName,
    };

    const theme = {
        container: classes.container,
        suggestionsContainerOpen: classes.suggestionsContainerOpen,
        suggestionsList: classes.suggestionsList,
        suggestion: classes.suggestion,
    };

    return (
        <div className={classes.root}>
            <Autosuggest
                {...autosuggestProps}
                inputProps={inputProps}
                theme={theme}
            />
        </div>
    );
};

Autocomplete.propTypes = {
    classes: PropTypes.objectOf(PropTypes.any).isRequired,
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string.isRequired,
    handleChange: PropTypes.func.isRequired,
    getSuggestions: PropTypes.func.isRequired,
    getHistory: PropTypes.func.isRequired,
    inputName: PropTypes.string.isRequired,
};

export default withStyles(styles)(Autocomplete);
